import Icon from '../components/Icon.vue'

Icon.register({
  crosshairs: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M500 224H469.6C455.7 130.3 381.7 56.3 288 42.4V12C288 5.4 282.6 0 276 0H236C229.4 0 224 5.4 224 12V42.4C130.3 56.3 56.3 130.3 42.4 224H12C5.4 224 0 229.4 0 236V276C0 282.6 5.4 288 12 288H42.4C56.3 381.7 130.3 455.7 224 469.6V500C224 506.6 229.4 512 236 512H276C282.6 512 288 506.6 288 500V469.6C381.7 455.7 455.7 381.7 469.6 288H500C506.6 288 512 282.6 512 276V236C512 229.4 506.6 224 500 224zM288 404.6V364C288 357.4 282.6 352 276 352H236C229.4 352 224 357.4 224 364V404.6C165.8 392.2 119.8 346.2 107.4 288H148C154.6 288 160 282.6 160 276V236C160 229.4 154.6 224 148 224H107.4C119.8 165.8 165.8 119.8 224 107.4V148C224 154.6 229.4 160 236 160H276C282.6 160 288 154.6 288 148V107.4C346.2 119.8 392.2 165.8 404.6 224H364C357.4 224 352 229.4 352 236V276C352 282.6 357.4 288 364 288H404.6C392.2 346.2 346.2 392.2 288 404.6zM288 256C288 273.7 273.7 288 256 288S224 273.7 224 256C224 238.3 238.3 224 256 224S288 238.3 288 256z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/crosshairs.js
// module id = rC9P
// module chunks = 144